var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('h1',[_c('b',[_vm._v("شیپ پُل")])]),_c('br'),_c('p',[_vm._v(" سامانه نظرسنجی و فرم شیپ پُل")])])}]

export { render, staticRenderFns }